import { LargeTitle } from "@/components/common/LargeTitle";
import { useMemo, useState } from "react";
import { useBrowse, useCategories } from "@/hooks/useMovies";
import { MovieGrid } from "@/components/movie/MovieRow";
import { GridSkeleton } from "@/components/skeleton/Skeletons";
import { EmptyState, ErrorState } from "@/components/common/States";
import { Page } from "@/components/common/Reveal";
import { Chip, Segmented } from "@/components/glass/Glass";
import { SORT_OPTIONS } from "@/components/search/FilterSheet";
import { IconFilm, IconTv } from "@/components/icons/Icons";
import { useSeo } from "@/lib/seo";

export default function Browse({ type }) {
  const [genre, setGenre] = useState("");
  const [sort, setSort] = useState("popular");
  const { data: cats } = useCategories();
  const { data, isLoading, isError, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage } = useBrowse({ type, genre, sort });
  const items = useMemo(() => (data?.pages || []).flatMap((p) => p.items), [data]);
  const title = type === "series" ? "Seriallar" : "Filmlar";
  useSeo({ title });

  return (
    <Page className="pk-pb-dock pt-[calc(76px+var(--safe-top))] lg:pt-28">
      <div className="pk-container">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <LargeTitle className="text-[30px] font-extrabold tracking-[-0.025em] text-white sm:text-[38px]" testId="browse-title">{title}</LargeTitle>
            <p className="mt-1 text-[14px] font-medium text-white/50">{data?.pages?.[0]?.total ?? "—"} ta</p>
          </div>
          <Segmented options={SORT_OPTIONS} value={sort} onChange={setSort} testId="browse-sort" size="sm" className="self-start sm:self-auto" />
        </div>
        <div className="pk-scroll-x -mx-4 mt-5 flex gap-2 overflow-x-auto px-4 sm:-mx-6 sm:px-6 lg:mx-0 lg:flex-wrap lg:px-0">
          <Chip active={!genre} onClick={() => setGenre("")} data-testid="browse-genre-all">Barchasi</Chip>
          {(cats?.items || []).filter((g) => g.count > 0).map((g) => (
            <Chip key={g.slug} active={genre === g.slug} onClick={() => setGenre(genre === g.slug ? "" : g.slug)} data-testid={`browse-genre-${g.slug}`}>{g.name}</Chip>
          ))}
        </div>
        <div className="mt-8">
          {isLoading ? (
            <GridSkeleton />
          ) : isError ? (
            <ErrorState error={error} onRetry={refetch} />
          ) : !items.length ? (
            <EmptyState icon={type === "series" ? IconTv : IconFilm} title={type === "series" ? "Seriallar hozircha yo‘q" : "Filmlar hozircha yo‘q"} text="Tez orada yangi kontent qo‘shiladi." testId="browse-empty" />
          ) : (
            <MovieGrid items={items} hasMore={Boolean(hasNextPage)} loadMore={fetchNextPage} loadingMore={isFetchingNextPage} testId="browse-grid" />
          )}
        </div>
      </div>
    </Page>
  );
}
